<div class="date-time-picker-wrapper" #pickerWrapper>
  <span class="title-name">{{ label }} @if (required) {
    <span class="mandatory-star">*</span>
  }</span>

  <div class="error-input-wrapper date-time-container" #pickerAnchor [class.picker-above]="pickerPlacement === 'above'">
    <div class="input-group" [class.picker-open]="showPicker" [class.picker-invalid]="showErrors">
      <input
        class="form-control"
        [value]="displayValue"
        readonly
        [disabled]="isDisabled"
        [class.datepicker-invalid]="showErrors"
        [attr.aria-label]="label || 'Date and time picker'"
        [attr.aria-expanded]="showPicker"
        aria-haspopup="dialog"
        (click)="openPicker($event)"
        (keydown)="onTriggerKeydown($event)"
        (blur)="onBlur()"
      />
      <button
        type="button"
        class="input-group-text picker-icon-btn"
        [class.datepicker-invalid]="showErrors"
        [disabled]="isDisabled"
        aria-label="Open date and time picker"
        (click)="openPicker($event)"
        (keydown)="onTriggerKeydown($event)">
        <mat-icon>calendar_today</mat-icon>
      </button>
    </div>

    @if (showPicker) {
      <div class="picker-backdrop" (click)="onBackdropClick($event)"></div>

      <dialog class="custom-date-time-picker-div" #pickerPanel open tabindex="-1" aria-modal="false"
        [attr.aria-label]="label || 'Date and time picker'" (cancel)="$event.preventDefault()"
        (click)="$event.stopPropagation()">
        <div class="picker-body">
          <div class="picker-calendar-section">
            <ngb-datepicker
              #datePicker
              [(ngModel)]="draftDate"
              outsideDays="hidden"
              [minDate]="resolvedMinDate"
              [maxDate]="maxDate"
              (ngModelChange)="onDateChange($event)">
            </ngb-datepicker>
          </div>

          <div class="picker-time-section">
            <ngb-timepicker
              class="custom_time_pick"
              size="small"
              [(ngModel)]="draftTime"
              (ngModelChange)="onTimeChange($event)"
              [spinners]="false"
              [meridian]="is12hrsFormat">
            </ngb-timepicker>
          </div>
        </div>

        <div class="picker-footer">
          <button type="button" mat-flat-button color="primary" class="ok-btn" (click)="onOkClick()">ok</button>
        </div>
      </dialog>
    }
    @if (timeZoneLabel) {
      <div class="timezone-label-under-input mt-2">
        <span class="title-name" style="font-size: 14px;">Time Zone: {{ timeZoneLabel }}</span>
      </div>
    }
  </div>

  @if (showErrors && errorMsg) {
    <mat-error class="picker-error">
      {{ errorMsg }}
    </mat-error>
  }
</div>
